module.exports = __webpack_public_path__ + "static/offer-design-summary-87331dc84ede9f6293aef5188ea7ac19.jpg";